module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.occurrences), function(occurrence, i) {
    return _c('div', {
      staticClass: "occurrence"
    }, [_c('el-button', {
      staticClass: "occurrence__remove-button",
      attrs: {
        "type": "danger",
        "size": "small",
        "title": "Usuń termin"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.removeItemFromFormset(_vm.occurrences, occurrence)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })]), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Data",
        "error": _vm.errors && _vm.errors[i] && _vm.errors[i]['date']
      }
    }, [_c('el-date-picker', {
      attrs: {
        "type": "date",
        "format": "yyyy/MM/dd",
        "value-format": "yyyy-MM-dd",
        "placeholder": "Data od"
      },
      model: {
        value: (occurrence.date),
        callback: function($$v) {
          _vm.$set(occurrence, "date", $$v)
        },
        expression: "occurrence.date"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Scena",
        "error": _vm.errors && _vm.errors[i] && _vm.errors[i]['stage']
      }
    }, [_c('el-select', {
      attrs: {
        "filterable": "",
        "clearable": "",
        "placeholder": "Scena"
      },
      model: {
        value: (occurrence.stage),
        callback: function($$v) {
          _vm.$set(occurrence, "stage", $$v)
        },
        expression: "occurrence.stage"
      }
    }, _vm._l((_vm.$store.state.stages), function(stage) {
      return _c('el-option', {
        key: stage.id,
        attrs: {
          "label": stage.name_pl,
          "value": stage.id
        }
      })
    }), 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Godzina rozpoczęcia",
        "error": _vm.errors && _vm.errors[i] && _vm.errors[i]['hour_from']
      }
    }, [_c('el-time-picker', {
      attrs: {
        "value-format": "HH:mm:ss",
        "placeholder": "Godzina rozpoczęcia"
      },
      model: {
        value: (occurrence.hour_from),
        callback: function($$v) {
          _vm.$set(occurrence, "hour_from", $$v)
        },
        expression: "occurrence.hour_from"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "Godzina zakończenia",
        "error": _vm.errors && _vm.errors[i] && _vm.errors[i]['hour_to']
      }
    }, [_c('el-time-picker', {
      attrs: {
        "value-format": "HH:mm:ss",
        "placeholder": "Godzina zakończenia"
      },
      model: {
        value: (occurrence.hour_to),
        callback: function($$v) {
          _vm.$set(occurrence, "hour_to", $$v)
        },
        expression: "occurrence.hour_to"
      }
    }), _vm._v(" "), _c('el-alert', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (occurrence.hour_from > occurrence.hour_to),
        expression: "occurrence.hour_from > occurrence.hour_to"
      }],
      attrs: {
        "title": "Podałeś godzinę następnego dnia.",
        "type": "warning",
        "show-icon": ""
      }
    })], 1)], 1), _vm._v(" "), (_vm.eventType === 'theater') ? _c('div', {
      staticClass: "inline-form-group"
    }, [_c('el-form-item', {
      attrs: {
        "label": "Liczba miejsc"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Liczba miejsc"
      },
      model: {
        value: (occurrence.number_of_seats),
        callback: function($$v) {
          _vm.$set(occurrence, "number_of_seats", $$v)
        },
        expression: "occurrence.number_of_seats"
      }
    })], 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addOccurrence
    }
  }, [_vm._v("Dodaj termin")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v("Terminy:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68682fde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Events/EventOccurrences.vue
// module id = 772
// module chunks = 0